import React from 'react'

export default function AutoComplete(props) {
    const [keyTimer, setKeyTimer] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [records, setRecords] = React.useState([]);

    React.useEffect(() => {
    }, [])

    return (
        <div className="searchBox" style={{ backgroundImage: `url("../Images/Report/Map/${inputValue.length > 0 ? 'Clear' : ''}Search.png")` }}>
            <input type="text" maxLength="30" placeholder="Search country or city" autoComplete="off" onKeyUp={OnKeyUp} onBlur={OnBlur} onFocus={OnFocus} value={inputValue} onChange={onChange} />
            <ul className="autocomplete" style={{ display: (records.length === 0) ? 'none' : 'block' }}>{
                records.map(item => typeof item !== 'undefined' ? <li key={item.id} onClick={() => props.select(item.value)}>{item.value}</li> : '')
            }</ul>
        </div>
    );
    function OnKeyUp(event) {
        const value = event.target.value;
        if (event.which === 13) {
            event.preventDefault();
            if (value.length >= props.minLength) {

                props.select(inputValue);
            }
            setRecords(() => []);
            setInputValue(() => '');
            ClearMenu();
            props.changed('');
        } else {
            ClearMenu();
            setKeyTimer((oldKeyTimerValue) => {
                clearTimeout(oldKeyTimerValue);
            });

            setKeyTimer(() => {
                return setTimeout(() => {
                    if (value.length >= props.minLength) {
                        props.source(value, (data) => {
                            setRecords(() => data);
                        });
                    } else
                        ClearMenu();
                }, 400, value);
            });
        }
    }
    function OnBlur() {
        console.log('OnBlur');
        setTimeout(() => {
            setInputValue(()=> '');
            ClearMenu();
            props.changed('');
        }, 300);
    }
    function OnFocus() {
        setInputValue(() => '');
    }
    function onChange(event) {
        const value = event.target.value;
        if (inputValue !== value)
            props.changed(value);
        setInputValue(()=>value);
    }
    function ClearMenu() {
        setRecords(() => []);
    }
}